export var EXPORE_ETF_LIST_DATA = "EXPORE_ETF_LIST_DATA";
export var EXPORE_ETF_STREAM = "EXPORE_ETF_STREAM";
export var EXPORE_ETF_LIST_ERROR = "EXPORE_ETF_LIST_ERROR";
export var EXPORE_ETF_LIST_HIDE_ERROR = "EXPORE_ETF_LIST_HIDE_ERROR";
export var EXPORE_ETF_LIST_START_LOADER = "EXPORE_ETF_LIST_START_LOADER";
export var EXPORE_ETF_LIST_STOP_LOADER = "EXPORE_ETF_LIST_STOP_LOADER";
